import {
  webinarPublicRepo,
  type WebinarPastDetail,
  type WebinarPublicSummary,
  type WebinarRegistrationEntry,
} from './webinar-public.repo'

export const webinarPublicService = {
  async getPublicSummary(id: string): Promise<WebinarPublicSummary> {
    if (!id) throw new Error('Webinar id is required')
    return webinarPublicRepo.getPublicSummary(id)
  },
  async getPastDetail(id: string): Promise<WebinarPastDetail> {
    if (!id) throw new Error('Webinar id is required')
    return webinarPublicRepo.getPastDetail(id)
  },
  async listRegistrations(id: string): Promise<WebinarRegistrationEntry[]> {
    if (!id) throw new Error('Webinar id is required')
    return webinarPublicRepo.listRegistrations(id)
  },
}

export type {
  WebinarPublicSummary,
  WebinarPublicSpeaker,
  WebinarPastDetail,
  WebinarRegistrationEntry,
  WebinarRecording,
  WebinarAttendanceTick,
} from './webinar-public.repo'
